export const FETCH_START = 'aiLayer/FETCH_START'
export const FETCH_SUCCESS = 'aiLayer/FETCH_SUCCESS'
export const FETCH_FAILURE = 'aiLayer/FETCH_FAILURE'
